export default {
  about_title: "关于我们",
  about_brand: "品牌故事",
  about_slogan: "爱猫人的温暖聚集地",
  about_stats: "社区数据",
  about_reputation: "用户口碑",
  about_contact: "联系我们",
  about_contact_desc: "我们非常乐意听取您的建议和反馈",
  contact_email: "电子邮箱",
  contact_wechat: "微信公众号",
  contact_weibo: "官方微博",
  contact_address: "办公地址",
  contact_phone: "联系电话",
  brand_story_title: "我们的故事",
  member_count_label: "注册会员",
  article_count_label: "文章总数",
  adoption_count_label: "成功领养",
};